<app-auth-layout>
  <div class="cont" [ngClass]="page">
    <img class="logo" src="./assets/images/logo.svg" />

    <form *ngIf="page === 'enter-email'" [formGroup]="form" (ngSubmit)="checkMethods()">
      <sync-button
        class="back"
        label="Back to sign in"
        type="flat"
        [leadAdornment]="true"
        leadIconAdornment="arrow-left"
        [onClick]="onClickBackToSignIn"
      />

      <h1>Forgot password</h1>

      <p>Enter your email address account.</p>

      <sync-text-field
        class="email-address"
        label="Email address"
        formControlName="emailAddress"
        [errorMessage]="getErrorMessage('emailAddress')"
      />

      <sync-button
        nativeType="submit"
        class="continue"
        label="Continue"
        [isLoading]="spinner"
        [disabled]="form.invalid"
        buttonWidth="236px"
      />
    </form>

    <ng-container *ngIf="page === 'select-mode'">
      <sync-button
        class="back"
        label="Back to sign in"
        type="flat"
        [leadAdornment]="true"
        leadIconAdornment="arrow-left"
        [onClick]="onClickBackToSignIn"
      />
      <h1>Forgot password</h1>

      <div class="modes" *ngIf="hasHint || hasReset">
        <div class="mode" *ngIf="hasReset" (click)="emailResetSubmit()">
          <span class="name">Reset my password via email</span>
          <span class="description">A link will be sent to your email to reset your password</span>

          <sync-icon name="chevron-right" />
        </div>
        <div class="mode" *ngIf="hasHint" (click)="emailHintSubmit()">
          <span class="name">Send a password hint</span>
          <span class="description">A hint you made will be sent to your email</span>
          <sync-icon name="chevron-right" />
        </div>
      </div>

      <ng-container *ngIf="!hasHint && !hasReset">
        <p>You do not have a password recovery method set up on your account.</p>
        <p>Please <a href="https://www.sync.com/support/" target="_blank">contact us</a> for further assistance.</p>
      </ng-container>

    </ng-container>

    <ng-container *ngIf="page === 'error'">
      <sync-button
        class="back"
        label="Back to sign in"
        type="flat"
        [leadAdornment]="true"
        leadIconAdornment="arrow-left"
        [onClick]="onClickBackToSignIn"
      />
      <h1>Forgot password</h1>

      <div class="modes">
        <a class="mode" href="https://www.sync.com/support/">
          <span class="name">Contact us</span>
          <span class="description">Please contact us for further assistance</span>
          <sync-icon name="chevron-right" />
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="page === 'password-reset-link-sent'">
      <h1>Password reset link sent</h1>

      <p>An email has been sent to <b>{{emailAddress}}</b> with further instructions.</p>

      <div class="reset-code">
        <label>Reset code:</label>
        <span class="code">{{resetCode}}</span>
      </div>

      <p>This is your randomly generated code, <b>you will need this code to complete the password reset</b> (write it down).</p>

      <sync-button
        label="Back to sign in"
        type="filled"
        [leadAdornment]="true"
        leadIconAdornment="arrow-left"
        [onClick]="onClickBackToSignIn"
      />
    </ng-container>

    <ng-container *ngIf="page === 'password-hint-sent'">
      <h1>Password hint sent</h1>
      <p>A password hint has been sent to your email address:</p>

      <span class="email">{{emailAddress}}</span>

      <sync-button
        label="Back to sign in"
        type="filled"
        [leadAdornment]="true"
        leadIconAdornment="arrow-left"
        [onClick]="onClickBackToSignIn"
      />
    </ng-container>
  </div>
</app-auth-layout>
